jQuery(window).on("load", function () {
    //scroll(0, 0);


    /*if ($('.tab-content').length > 0) {
        $('body,html').animate({
            scrollTop: $('.tab-content').offset().top - 73
        }, 800);
    }*/

    if ($("header").offset().top > 100) {
        setTimeout(function () {
            $('header').addClass('menu-up');
        }, 100);
    }

    if ($("div").is("#map")) {
        if ($(window).width() > 1200) {
            initMap();
        } else {

            $(".load-map").click(function () {
                initMap();
            });

        }
    }

    [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function () {
            img.removeAttribute('data-src');
        };
    });

    if ($(window).width() > 1200) {
        for (var i = 0; i < $('.services .item .row').length; i++) {
            $($('.services .item .row .img')[i]).parent().height($($('.services .item .text h2')[i]).parent().parent().height())
            console.log($($('.services .item .text h2')[i]).parent().parent().height());
        }
    }

});

$(document).ready(function () {

    $("#menu").mmenu({
        "extensions": [
                "position-right",
                "pagedim-black",
                "border-offset"
             ],
        classNames: {
            fixedElements: {
                fixed: "fix-menu"
            },
            vertical: "expand"
        }
    });

    $("#menu").mhead();

    var api = $('#menu').data('mmenu');
    api.bind("close:finish", function () {
        $('.ham').removeClass('active');
        $('.icon').removeClass('open');
    });

    var location = window.location.href;
    var cur_url = location.split('/').pop();

    $('header nav ul li, footer li').each(function () {
        var link = $(this).find('a').attr('href');

        if (cur_url == link) {
            $(this).find('a').addClass('current');
        }
    });

    if ($(window).width() < 1200) {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('.fix-menu').addClass('mh-scrolledout');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }

            lastScrollTop = st;
        });
    } else {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('header').addClass('menu-up');
            } else if (st == 0) {
                $('header').removeClass('menu-down');
            } else {
                $('header').removeClass('menu-up');
                $('header').addClass('menu-down');
            }
            lastScrollTop = st;
            if (st > 0) {
                $('.about-block .col-lg-8 div, .immigrations-block .col-lg-8 div').css('opacity', '1');
            }
        });

        /*$(".first-screen, .financial-block, .legal-block, .team-block .img-block").paroller({
            factor: 0.3,
            factorXs: 0.1,
            type: 'background',
            direction: 'vertical'
        });*/

        $(".team-block .item-1").paroller({
            factor: 0.13,
            type: 'foreground',
            direction: 'vertical'
        });

        $(".team-block .item-2").paroller({
            factor: 0.22,
            type: 'foreground',
            direction: 'vertical'
        });

        $(".team-block .item-3").paroller({
            factor: 0.27,
            type: 'foreground',
            direction: 'vertical'
        });

        $(".team-block .item-4").paroller({
            factor: 0.12,
            type: 'foreground',
            direction: 'vertical'
        });

        $(".team-block .item-5").paroller({
            factor: 0.29,
            type: 'foreground',
            direction: 'vertical'
        });
    }

    /*$(window).scroll(function (event) {
        var scroolMore = $(window).scrollTop();
        $('body,html').animate({
            scrollTop: scroolMore + 20
        }, 1000);
        console.log($(window).scrollTop());
    });*/

    jQuery('textarea').autoResize();
    var greenColor = String('#28a745');
    var redColor = String('#E11B16');

    jQuery(function () {
        var form = $('.contact-block form');
        var formInfo = $('.contact-block form .info');
        $(form).validate({
            submitHandler: function (form) {
                $(form).ajaxSubmit({
                    clearForm: true,
                    success: function () {
                        $(form).find("input, textarea").val("");
                        $(formInfo).css('color', greenColor);
                        $(formInfo).text('Thanks! Your request has been sent. Our staff will contact you.');
                        $(formInfo).slideDown();
                        setTimeout(function () {
                            $(formInfo).slideUp();
                        }, 7000)
                    },
                    error: function () {
                        $(form).find("input, textarea").val("");
                        $(formInfo).css('color', redColor);
                        $(formInfo).text('Your request has not been sent. Try again in a few minutes.');
                        $(formInfo).slideDown();
                        setTimeout(function () {
                            $(formInfo).slideUp();
                        }, 7000)
                    }
                });
            }
        });
    });

    /*$(".angle, .team-block .angle-l, .team-block .angle-r").paroller({
        factor: 0.13,
        type: 'foreground',
        direction: 'vertical'
    });*/



    $(".partners-block .line-1, .partners-block .line-2, .experience .line-1, .experience .line-2, .first-screen .line-2").paroller({
        factor: 0.17,
        type: 'foreground',
        direction: 'horizontal'
    });

    $(".legal-block .line, .first-screen .line-1, .team-block .line-1, .team-block .line-2, .services .line").paroller({
        factor: 0.17,
        type: 'foreground',
        direction: 'vertical'
    });

    $('.slider-team').slick({
        lazyLoad: 'ondemand',
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $(".slider-team .slick-slide").hover(
        function () {
            $(".slider-team .slick-slide").css('opacity', '.5')
            $(this).css('opacity', '1')
        },
        function () {
            $(".slider-team .slick-slide").css('opacity', '.5')
            $(".slider-team .slick-slide.slick-current").css('opacity', '1')
        }
    );

    $('.jarallax').jarallax({
        speed: 0.1
    });

    $('.privacy .d-flex a').click(function () {
        $('.privacy .d-flex a').removeClass('active');
        $(this).addClass('active');
    })

    new WOW().init();

    $('.lang.mm-listitem a').each(function () {
        var link = $(this).attr('href');
        if (cur_url == link) {
            $(this).addClass('current');
        }
    });

    $('.lang .wrap').click(function () {
        $(this).next().toggleClass('show');
        $(this).toggleClass('show');
    });

    $(document).mouseup(function (e) {
        var container = $(".lang");
        if ($(".lang").has(e.target).length === 0) {
            $('.lang ul').removeClass('show');
            $('.lang .wrap').removeClass('show');
        }
    });

});
